import {
  createFileRoute,
  notFound,
  useMatchRoute,
} from '@tanstack/react-router';
import { z } from 'zod';
import { useHierarchyEndpoint } from '~/api/useHierarchyEndpoint';
import { TableAgDocuments } from '~/components/ui/tables/ag/documentsTable/TableAgDocuments';
import { canAccess } from '~/utils/rbac';

const documentSearchSchema = z.object({
  mode: z
    .enum(['table', 'docOverview', 'docCompare', 'editDocument'])
    .optional(),
  docId: z.string().optional(),
  docIds: z.array(z.string()).optional(),
  pageStart: z.number().optional(),
  pageEnd: z.number().optional(),
  x1: z.number().optional(),
  y1: z.number().optional(),
  x2: z.number().optional(),
  y2: z.number().optional(),
});
export type DocumentSearchSchema = z.infer<typeof documentSearchSchema>;
export const Route = createFileRoute('/_authLayout/documents/fund/$fundId')({
  beforeLoad: async () => {
    if (!canAccess('document')) {
      throw notFound();
    }
  },
  component: DocumentItemComponent,
  validateSearch: documentSearchSchema,
});

function DocumentItemComponent() {
  const hierarchy = useHierarchyEndpoint();
  const match = useMatchRoute();
  const fundIdMatch = match({ to: '/documents/fund/$fundId' });

  if (!fundIdMatch) {
    return null;
  }

  return (
    <>
      <TableAgDocuments
        hierarchy={hierarchy.fundHierarchy}
        fundId={fundIdMatch && fundIdMatch?.fundId}
      />
    </>
  );
}
